// extracted by css-extract-rspack-plugin
export default {"cls1":"Bookmarkers-cls1_mlw","cls2":"Bookmarkers-cls2_6Cy Bookmarkers-cls1_mlw"};